import toast from 'react-hot-toast';

export function buildPublicUrl(tipo, publicId) {
  if (!publicId) return null;
  const base = window.location.origin;
  const path = {
    mascota: 'mascota',
    actividad: 'actividad',
    campana: 'campana',
    urgente: 'urgente'
  }[tipo];
  if (!path) return null;
  return `${base}/${path}/${publicId}`;
}

function clean(s) {
  if (s == null) return '';
  const t = String(s).trim();
  if (!t || t === 'undefined' || t === 'null') return '';
  return t;
}

function clip(lines) {
  return lines.filter(Boolean).join('\n');
}

/**
 * Texto listo para pegar. Generado solo con campos públicos reales.
 * @param {{tipo:string, data?:object, url:string, title?:string, text?:string}} p
 */
export function buildShareText({ tipo, data, url, title, text }) {
  const d = data || {};
  const safeUrl = clean(url);
  const fallbackTitle = clean(title);
  const fallbackBody = clean(text);
  let head = '';
  let body = '';

  if (tipo === 'mascota') {
    const nombre = clean(d.nombre);
    head = nombre ? `🐾 ${nombre} — Red Cimarrona` : (fallbackTitle || 'Red Cimarrona');
    const meta = [clean(d.especie), clean(d.edad), clean(d.tamano)]
      .filter(Boolean)
      .join(' · ');
    const loc = clean(d.ubicacion) ? `📍 ${clean(d.ubicacion)}` : '';
    const historia = clean(d.historia) ? clean(d.historia).slice(0, 180) : '';
    body = clip([meta, loc, historia || fallbackBody]);
  } else if (tipo === 'actividad') {
    const nombre = clean(d.nombre);
    head = nombre ? `📅 ${nombre} — Red Cimarrona` : (fallbackTitle || 'Red Cimarrona');
    const desc = clean(d.descripcion) ? clean(d.descripcion).slice(0, 180) : '';
    const loc = clean(d.ubicacion) ? `📍 ${clean(d.ubicacion)}` : '';
    body = clip([desc || fallbackBody, loc]);
  } else if (tipo === 'campana') {
    const titulo = clean(d.titulo) || clean(d.nombre);
    head = titulo ? `❤️ ${titulo} — Red Cimarrona` : (fallbackTitle || 'Red Cimarrona');
    const desc = clean(d.descripcion) ? clean(d.descripcion).slice(0, 180) : '';
    body = clip([desc || fallbackBody]);
  } else if (tipo === 'urgente') {
    const nombre = clean(d.nombre);
    const prefix = d.esUrgente === false ? '' : '🚨 ';
    head = nombre
      ? `${prefix}${nombre} — Red Cimarrona`
      : (fallbackTitle || 'Red Cimarrona');
    const desc = clean(d.descripcion) ? clean(d.descripcion).slice(0, 180) : '';
    const loc = clean(d.ubicacion) ? `📍 ${clean(d.ubicacion)}` : '';
    body = clip([desc || fallbackBody, loc]);
  } else {
    head = fallbackTitle || 'Red Cimarrona';
    body = fallbackBody;
  }

  const parts = [head, body];
  if (safeUrl) parts.push(`Conoce más:\n${safeUrl}`);
  return clip(parts);
}

export function canNativeShare() {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

/** Copia al portapapeles con fallback a textarea + execCommand. */
export async function copyToClipboard(value) {
  const str = String(value ?? '');
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(str);
      return true;
    } catch {
      /* fallback below */
    }
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = str;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, str.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

export async function copyLink(url) {
  if (!url) return false;
  const ok = await copyToClipboard(url);
  if (ok) toast.success('✓ Enlace copiado');
  else toast.error('No se pudo copiar. Intenta nuevamente.');
  return ok;
}

export async function copyShareText(text) {
  if (!text) return false;
  const ok = await copyToClipboard(text);
  if (ok) toast.success('✓ Texto copiado');
  else toast.error('No se pudo copiar. Intenta nuevamente.');
  return ok;
}

/** Abre el share nativo del SO. No copia como fallback (eso es opción del menú). */
export async function nativeShare({ title, text, url }) {
  if (!canNativeShare() || !url) return false;
  try {
    await navigator.share({
      title: title || undefined,
      text: text || undefined,
      url
    });
    return true;
  } catch (err) {
    if (err && err.name === 'AbortError') return false;
    return false;
  }
}
